import { _ as __rest, g as getUserDetails, u as useAnalyticsPageView, a as __assign, b as getPagePath } from '../useAnalyticsPageView-f7488e50.js';
import React from 'react';
import { Route } from 'react-router-dom';
import { ConfigConsumer, UserProfileConsumer, GuestUserConsumer } from '@chr/navisphereonline-shared-components';
import '@chr/react-analytics';
import '@chr/online-shared-microsite-core';

var WrappedComponent = function (props) {
    var name = props.name, pagePath = props.pagePath, pageName = props.pageName, component = props.component, render = props.render, isGuest = props.isGuest, user = props.user, rest = __rest(props, ["name", "pagePath", "pageName", "component", "render", "isGuest", "user"]);
    var userDetails = getUserDetails(user, isGuest);
    useAnalyticsPageView({ siteName: "".concat(name), pagePath: pagePath, pageName: pageName, userId: userDetails.userId, userType: userDetails.userType, userEmail: userDetails.userEmail });
    if (component) {
        return React.createElement(component, rest);
    }
    else if (render) {
        var value = render(__assign({}, rest));
        return React.createElement(React.Fragment, null, value);
    }
    else {
        return null;
    }
};
var AnalyticsRoute = function (_a) {
    var path = _a.path, component = _a.component, pageName = _a.pageName, render = _a.render, rest = __rest(_a, ["path", "component", "pageName", "render"]);
    var pagePath = getPagePath(path);
    function getProps(name, userProfile, isGuest) {
        var props = __assign(__assign({}, rest), { path: path });
        if (component && name) {
            props.render = function (p) {
                return React.createElement(WrappedComponent, __assign({}, p, { name: name, component: component, pagePath: pagePath, pageName: pageName, user: userProfile, isGuest: isGuest }));
            };
        }
        else if (render && name) {
            props.render = function (p) {
                return React.createElement(WrappedComponent, __assign({}, p, { name: name, render: render, pagePath: pagePath, pageName: pageName, user: userProfile, isGuest: isGuest }));
            };
        }
        else {
            throw ("render or component needs to be defined");
        }
        return props;
    }
    return (React.createElement(ConfigConsumer, null, function (config) {
        return React.createElement(UserProfileConsumer, null, function (userProfile) {
            return React.createElement(GuestUserConsumer, null, function (guestProfile) {
                return React.createElement(Route, __assign({}, getProps(config.name, userProfile, guestProfile)));
            });
        });
    }));
};

export { AnalyticsRoute, WrappedComponent };
//# sourceMappingURL=index.es.js.map
